import { GenericLandingCard, GenericLandingCardHeader } from "components";
import { GenericBackToBtn, ResendVerifyEmailBtn } from "components/buttons";
import { useAppSelector } from "../store/store";
import {
  buttonBack,
  verifyEmailSubTitle,
  verifyEmailSubTitle2,
  ResetPasswordTitle,
} from "../_constants";

export const VerifyEmailResetPasswordPage = () => {
  const email = useAppSelector(
    (state) => state.resetPasswordFormSlice.value.email
  );
  return (
    <GenericLandingCard
      rightColumn={
        <GenericLandingCardHeader
          title={ResetPasswordTitle}
          subtitle={
            <>
              {verifyEmailSubTitle}
              <span className="font-weight-700">{` ${email}`}</span>
              {verifyEmailSubTitle2}
            </>
          }
          gap={16}
        ></GenericLandingCardHeader>
      }
      leftInteraction={
        <GenericBackToBtn label={buttonBack} link="/reset-password" />
      }
      rightInteraction={<ResendVerifyEmailBtn isRegisterFlow={false} />}
    ></GenericLandingCard>
  );
};
